import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';


@Injectable()
export class B2dProvider {


    private datas = {};

    constructor(private http: HttpClient) {

    }

    public getJSON(path): Observable<any> {
        return this.http.get("./assets/data/" + path);
    }


    public setDatas(o) {
        var merged = {...this.datas, ...o}
        this.datas = merged;

        //console.log(this.datas);

    }

    public getDatas() {
        return this.datas;
    }


    public getStoredDatas() {
        return this.datas;
    }

    public findDeviceInternalNameByModel() {

        return this.getJSON('phonehouse.json').toPromise();

    }
}



// WEBPACK FOOTER //
// ./src/providers/b2d/b2d.ts